import { createReducer, on } from "@ngrx/store";
import { IUser } from "src/app/interfaces";
import { UserActions } from "./actions";

export interface UserState {
  currentUser: IUser;
  error: string;
  loaded: boolean;
}

const initialState: UserState = {
  currentUser: {
    id: 0,
    displayName: "NA",
    imageSrc: null,
    roles: [],
    login: "",
    languages: "",
    preferredLanguage: "",
    email: "",
    isAadGuest: false
  },
  error: "",
  loaded: false
};

export const userReducer = createReducer<UserState>(
  initialState,
  on(UserActions.loadCurrentUserSuccess, (state, action): UserState => {
    return {
      ...state,
      currentUser: action.user,
      loaded: true
    };
  }),
  on(UserActions.loadCurrentUser, (state): UserState => {
    return {
      ...state,
      loaded: false
    };
  }),
  on(UserActions.loadCurrentUserFailure, (state, action): UserState => {
    return {
      ...state,
      error: action.error,
      loaded: false
    };
  })
);
